

























import { Component, Vue } from 'vue-property-decorator';
import swert from '@/component/swert.vue';
import wx from '@/util/wx';
import Cookies from 'js-cookie';

const { VUE_APP_FCAPI: FCAPI, VUE_APP_CSRF: CSRF } = process.env;

const API = {
  join: `${FCAPI}/vm/jia/apply`,
};

@Component({
  components: {
    swert,
  },
})
export default class IncubationCamp extends Vue {
  swert_msg: string = '';
  name: string = '';
  phone: string = '';
  company_name: string = '';
  is_show: boolean = false;
  is_wx: boolean = false;
  scroll: number = 0;
  timer: number = 0;

  handleScroll() {
    this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    if (this.scroll > 500) {
      this.is_show = true;
    } else {
      this.is_show = false;
    }
  }

  // 回到顶部的报名按钮处
  goTop() {
    cancelAnimationFrame(this.timer);
    this.timer = requestAnimationFrame(this.animationFn);
  }
  animationFn() {
    const oTop = document.body.scrollTop || document.documentElement.scrollTop;
    if (oTop > 0) {
      scrollTo(0, oTop - 100);
      this.timer = requestAnimationFrame(this.animationFn);
    } else {
      cancelAnimationFrame(this.timer);
    }
  }

  async submit() {
    if (!this.name) {
      this.swert_msg = '请输入姓名';
      return;
    }
    if (!this.phone) {
      this.swert_msg = '请输入手机号';
      return;
    }
    if (!/^1\d{10}$/.test(this.phone)) {
      this.swert_msg = '请输入正确的手机号';
      return;
    }
    if (!this.company_name) {
      this.swert_msg = '请输入品牌名称';
      return;
    }
    const res = await this.$axios.post(API.join, {
      name: this.name,
      mobile: this.phone,
      company: this.company_name,
    });
    if (res.data.status === 500) {
      this.swert_msg = '您已经报过名啦～';
      return;
    } else {
      this.swert_msg = '出错了，请稍后再试';
    }
    this.$router.push({
      path: '/join-success',
    });
  }

  created() {
    if (!Cookies.get(CSRF)) {
      this.$router.push({
        path: '/login',
      });
    }
  }

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.SHARE = {
      title: '家装家居行业线上线下双导购技能训练营',
      description: '小白入门，打通必要环节，开启大家装直播时代',
      url: window.location.href,
      icon_url: 'https://static.tugou.com/jia/m/apply/img/share.png',
    };
    wx.init();
    wx.bindShare();
    wx.bindShareTimeLine();
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
